export const STEAM_TRANSACTION_STATUSES = {
  INITED: 'inited',
  SUCCEEDED: 'succeeded',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
};

export type SteamTransactionStatus = typeof STEAM_TRANSACTION_STATUSES[keyof typeof STEAM_TRANSACTION_STATUSES];
